import { render, staticRenderFns } from "./loginc.vue?vue&type=template&id=7dde5130&scoped=true"
import script from "./loginc.vue?vue&type=script&lang=js"
export * from "./loginc.vue?vue&type=script&lang=js"
import style0 from "./loginc.vue?vue&type=style&index=0&id=7dde5130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dde5130",
  null
  
)

export default component.exports